<template>
  <div class="aframe-360-viewer">
    <v-snackbar v-model="snackbar" vertical :timeout="0" top>
      <h2>Apresentação da Prática: <span class="primary--text">{{ getFirstPracticeIntroTitle() }}</span></h2> <br>
      {{ getFirstPracticePresentation() }}
      <v-btn dark text @click="snackbar = false">
        {{ getTranslation(
        'Fechar',
        'Cerrar')
       }}
      </v-btn>
    </v-snackbar>
    <v-btn large class="floating-button" @click="$emit('selectComponent', 'CoreEtapa3'), $emit('nextStep', '3')">
      {{ getTranslation(
        'Ok',
        'Ok')
       }}
    </v-btn>
  </div>
</template>

<script>
import Const from '@/helpers/const'
let json = require('../../json/pratica-' + Const.PRACTICE_NUMBER + '.json')
export default {
  data() {
    return {
      snackbar: true,
      json: json
    }
  },

  methods: {
    getFirstPracticeIntroTitle() {
      const pratica = this.json.pratica[0]
      return pratica.introducao.titulo
    },

    getFirstPracticePresentation() {
      const pratica = this.json.pratica[0]
      return pratica.apresentacao
    },
    getTranslation(elementPortuguese, elementSpanish){
      if(Const.PRACTICE_NUMBER.includes('es')){
        return elementSpanish
      }
      return elementPortuguese
    },

  }
}
</script>

<style scoped>
.aframe-360-viewer {
  background-color: #ffffff;
  overflow: hidden;
  height: 100vh;
  width: 100vw;
}

.floating-button {
  position: absolute;
  bottom: 100px;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
}

@media only screen and (max-width: 800px) {
  .floating-button {
    bottom: var(--button-position);
    width: 100%;
  }
}
</style>
